import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import './Header.css';
import Logout from "../Logout/Logout";
import MenuItem from 'material-ui/MenuItem';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import AppBar from 'material-ui/AppBar';
import Drawer from 'material-ui/Drawer';
import Popover from 'material-ui/Popover';
import Logo from '../../Assets/Images/logo.png';
import HomeIcon from '../../Assets/Images/home.svg';
import InboxIcon from '../../Assets/Images/inbox.svg';
import ContentIcon from '../../Assets/Images/content.svg';
import DropdownArrow from '../../Assets/Images/arrow-dropdown.png';
import { reactTranslateChangeLanguage } from 'translate-components';
import Translate from 'translate-components';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import MoreVertical from '../../Assets/Images/more_vertical.svg';


class Header extends Component {
  constructor() {
    super();
    this.state = {
      userName: '',
      companyName: '',
      open: false,
      logoutToggle: false,
    };

    this.userInfo = this.userInfo.bind(this);
    this.handleLogoutToggle = this.handleLogoutToggle.bind(this);
  }
  /*
    * Information about logged user - that's outputting in header component.
   */
  userInfo() {
    const userInformation = this.props.userData;
    let userName = userInformation.user_name;
    this.setState({ userName: userName });
    let companyName = userInformation.user_company_name;
    this.setState({ companyName: companyName });
  }

  handleToggle = () => this.setState({ open: !this.state.open });

  handleLogoutToggle = (event) => {

    this.setState({
      logoutToggle: true,
      anchorEl: event.currentTarget,
    });
  }

  handleRequestClose = () => {
    this.setState({
      logoutToggle: false,
    });
  };


  componentDidMount() {
    this.userInfo();
  };

  render() {

    let path = '';


    if (window.location.href.indexOf('/request/list') > -1) {
      path = ('Lista zahteva');
    }

    if (window.location.href.indexOf('/request/add') > -1) {
      path = ('Kreiranje naloga');
    }

    if (window.location.href.indexOf('/request/material/spending') > -1) {
      path = ('Potrošnja materijala');
    }

    return (
      <div>
        <header className="App-header">
          <MuiThemeProvider>
            <div style={{ position: "relative" }}>
              <AppBar
                title={<Translate>{path}</Translate>}
                style={{ backgroundColor: "#90CAF9", zIndex: 1003 }}
                onClick={this.handleToggle}
                className="appbar-title"
              />
              <IconMenu
                className="lang-switcher"
                iconButtonElement={<IconButton><img alt="language menu" src={MoreVertical} /></IconButton>}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                style={{ zIndex: 5000, position: "absolute", top: 0, right: 0 }}
                targetOrigin={{ horizontal: 'right', vertical: 'top' }}
              >
                <MenuItem
                  primaryText="English"
                  className="language-link-en language-link"
                  onClick={() => {
                    reactTranslateChangeLanguage("en");
                    localStorage.setItem('selectedLang', 'en');
                  }
                  }
                />
                <MenuItem
                  className="language-link-sr language-link"
                  primaryText="Srpski"
                  onClick={() => {
                    reactTranslateChangeLanguage("sr");
                    localStorage.setItem('selectedLang', 'sr');
                  }}

                />

              </IconMenu>
              <Drawer
                open={this.state.open}
                className={"container-mobile"}
                containerStyle={{ top: 0, bottom: 0, position: "absolute", float: "left", height: "100vh", width: 225, paddingTop: 64, zIndex: 1000 }}
              >
                <div className="c-ie11-fix">
                  <div className={"popover-logout"}>
                    <img className={"header-logo"} src={Logo} alt="" />
                    <p>{this.state.userName.toUpperCase() + " - " + this.state.companyName}</p>
                    <span onClick={this.handleLogoutToggle} className="toggleButtonUser">
                      <img className={"dropdown-arrow"} src={DropdownArrow} alt="" />
                    </span>

                  </div>
                </div>
                <Popover
                  onRequestClose={this.handleRequestClose}
                  className={"logout-container-btn"}
                  style={{ width: 205, height: 70, left: 12, display: "flex", justifyContent: "left", alignItems: "center", zIndex: 4004 }}
                  anchorEl={this.state.anchorEl}
                  anchorOrigin={{ horizontal: 'middle', vertical: 'bottom' }}
                  targetOrigin={{ horizontal: 'middle', vertical: 'top' }}
                  open={this.state.logoutToggle}
                >
                  <Logout
                    className="btn-logout" {...this.props}
                  />
                </Popover>
                <MenuItem>
                  <NavLink activeClassName="active-links" className="r-links" style={{ display: "block" }} to={'/request/add'}>
                    <img alt="home" src={HomeIcon} className={"menu-icon"}></img> <Translate>Kreiranje zahteva</Translate>
                  </NavLink>
                </MenuItem>
                <MenuItem>
                  <NavLink activeClassName="active-links" className="r-links" to={'/request/list'}>
                    <img alt="listing requests" src={InboxIcon} className={"menu-icon"} />   <Translate>Lista zahteva</Translate>
                  </NavLink>
                </MenuItem>
                <MenuItem>
                  <NavLink activeClassName="active-links" className="r-links" to={'/request/material/spending'}>
                    <img alt="spending materials" src={ContentIcon} className={"menu-icon"} />  <Translate>Potrošnja materijala</Translate>
                  </NavLink>
                </MenuItem>
              </Drawer>
            </div>
          </MuiThemeProvider>
        </header>
      </div >
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header/Header.jsx